export default function Journey() {
    return (
        <div className="md:rounded-[120px] rounded-[70px] bg-gradient-to-b from-[#fdedce] via-transparent to-[#fdedce] ">
            <div className="container mx-auto my-16">
                <div className="md:space-y-0 md:space-x-4 flex md:flex-row flex-col items-center space-y-5 px-10 md:pt-20 md:pb-20">
                    <div className="md:w-2/4 w-full md:text-left text-center">
                        <img
                            src="/assets/about-us/journey.webp"
                            alt="A silhouette of a businessman in a suit standing on a mountain peak at sunset, planting a black flag. Two overlay icons show a line graph and a dashed-line route."
                            title="Business success and achievement."
                            className="md:block hidden"
                        />
                        <img
                            src="/assets/about-us/journey-mobile.webp"
                            alt="A silhouette of a businessman in a suit standing on a mountain peak at sunset, planting a black flag. Two overlay icons show a line graph and a dashed-line route."
                            title="Business success and achievement."
                            className="md:hidden pt-[50px]"
                        />
                    </div>
                    <div className="md:w-2/4 w-full">
                        <h3 className="md:text-[35px] md:leading-[2.5rem] text-3xl font-bold text-start md:pt-10">
                            <span>The </span>
                            <span className="olm-gradient-text">Journey</span>
                            <span> and the </span>
                            <span className="olm-gradient-text">Grind</span>
                        </h3>
                        <br />
                        <p className="md:text-[20px] text-[18px] md:mr-[2.75rem] text-start md:pb-0 pb-[70px] font-medium">
                            Our success didn&apos;t come easily. It was carved
                            out of countless nights of hard work, balancing a
                            full-time job, family commitments, and the demands
                            of real estate investing. From developing systems to
                            handle the influx of responses to constantly
                            tweaking our strategies for maximum impact,
                            we&apos;ve been through it all. This isn&apos;t just
                            a business for us; it&apos;s a passion born out of
                            real-life experiences and challenges.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
